import React, { useRef, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Horizontal carousel with prev/next arrows + auto-scroll. Children are the cards.
const Carousel = ({ children, auto = true, interval = 3500 }) => {
  const ref = useRef(null);

  const scrollByCards = (dir) => {
    const el = ref.current;
    if (!el) return;
    const amount = el.clientWidth * 0.8 * dir;
    if (dir > 0 && el.scrollLeft + el.clientWidth >= el.scrollWidth - 5) {
      el.scrollTo({ left: 0, behavior: "smooth" });
    } else {
      el.scrollBy({ left: amount, behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (!auto) return;
    const id = setInterval(() => scrollByCards(1), interval);
    return () => clearInterval(id);
  }, [auto, interval]);

  return (
    <div className="relative group">
      <button onClick={() => scrollByCards(-1)} aria-label="Previous"
        className="absolute -left-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-white shadow-lg ring-1 ring-black/5 flex items-center justify-center text-gray-700 hover:text-primary hover:bg-secondary transition-colors">
        <ChevronLeft className="w-5 h-5" />
      </button>
      <div ref={ref} className="flex gap-4 overflow-x-auto no-scrollbar pb-2 scroll-smooth snap-x">
        {children}
      </div>
      <button onClick={() => scrollByCards(1)} aria-label="Next"
        className="absolute -right-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-white shadow-lg ring-1 ring-black/5 flex items-center justify-center text-gray-700 hover:text-primary hover:bg-secondary transition-colors">
        <ChevronRight className="w-5 h-5" />
      </button>
    </div>
  );
};

export default Carousel;
